export class iResponseInfo {
    public isSuccess: boolean;
    public isWarning: boolean;
    public isError: boolean;
    public message: string;

    constructor() {
        this.isSuccess = false;
        this.isWarning = false;
        this.isError = false;
        this.message = "";
    }
}




// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/interfaces/shared/iResponseInfo.ts